/*
* 主入口
*/

import './css/app.css';
import { useState, useEffect } from 'react';
import {
    Layout,
    message,
    ConfigProvider,
    theme,
} from 'antd';
import { createBrowserHistory } from 'history';
import cookie from 'react-cookies';
import $ from 'jquery';
import CNF from './incs/Config';
import {
    locale,
    AddRequestHeaders,
    DeleteCookies,
    winHeight,
} from './incs/FunHelper';

import ServiceReleaseMessage from './components/ServiceReleaseMessage';
import XHeader from './components/XHeader';
import XMenuLogo from './components/XMenuLogo';
import XMenu from './components/XMenu';
import XFooter from './components/XFooter';

/*
 ***************************************************
 ** 模块页面 **
 ***************************************************
 */

// 组织管理
import OrgInfo from './pages/orgs/OrgInfo';
import OrgStructure from './pages/orgs/OrgStructure';
import OrgStructureGraph from './pages/orgs/OrgStructureGraph';
import OrgApikey from './pages/orgs/OrgApikey';

// 账户管理
import Users from './pages/users/Users';
import UserInfos from './pages/users/UserInfos';

// 团队管理
import Groups from './pages/groups/Groups';

// 角色管理
import Roles from './pages/roles/Roles';

// 权限管理
import Authoritys from './pages/authoritys/Authoritys';

// 统计报表
import UserUTACD from './pages/reports/UserUTACD';
import UserUDATC from './pages/reports/UserUDATC';
import UserUDEBC from './pages/reports/UserUDEBC';
import UserUDSXC from './pages/reports/UserUDSXC';
import UserUTECY from './pages/reports/UserUTECY';
import UserUDBCY from './pages/reports/UserUDBCY';

// 日志管理
import LogOperations from './pages/logs/LogOprations';
import LogLogins from './pages/logs/LogLogins';

// 账户设置
import Seurity from './pages/securitys/Security';
import BasicInfo from './pages/basicinfo/BasicInfo';

// 主题色全局变量
global.THEMECOLOR = CNF.themeColors[0];

const { Sider, Content } = Layout;
const history = createBrowserHistory();

const { defaultAlgorithm, compactAlgorithm } = theme;
const Main = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [collapsed, setCollapsed] = useState(false);

    const [preGroup, setPreGroup] = useState('');
    const [navLists, setNavLists] = useState([]);
    const [btnLists, setBtnLists] = useState([]);
    const [serInfos, setSerInfos] = useState([]);
    const [serCodes, setSerCodes] = useState([]);

    // 切换模块
    const [m, setM] = useState(props.m);

    const {
        token: {
            colorWhite,             // 不随主题变化的纯白色
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            // colorPrimaryActive,     // 主色激活态颜色
            // colorPrimaryBgHover,    // 主色浅色背景悬浮态
            borderRadiusLG,
            // colorPrimaryBorder,

        },
    } = theme.useToken();

    useEffect(() => {
        $.ajax({
            url: `${CNF.api}policys`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done(function (data) {
            if (data.res === 0) {
                // 获取服务代码
                let serCodes = [];
                for (let i = 0; i < data.dat.nav_lists.length; i++) {
                    let serCode = data.dat.nav_lists[i].ptn.split('_')[1];
                    if (!serCodes.some(obj => obj === serCode)) {
                        serCodes.push(serCode);
                    }
                }
                setPreGroup(data.dat.pre_group);
                setNavLists(data.dat.nav_lists);
                setBtnLists(data.dat.btn_lists);
                setSerInfos(data.dat.ser_infos);
                setSerCodes(serCodes);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    // 若获取策略失败，直接退出登录
                    DeleteCookies();
                }, CNF.messageDuration * 1000);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
            setTimeout(function () {
                // 若获取策略失败，直接退出登录
                DeleteCookies();
            }, CNF.messageDuration * 1000);
        });
    }, [messageApi]);


    useEffect(() => {
        // 更新 url
        if (m > 10) {
            var i = Math.floor(parseInt(m) / 10);
            var j = parseInt(m % 10)
            history.push(CNF.basename ? `${CNF.basename}${CNF[props.nav][i - 1].submenu[j].url}` : CNF[[props.nav]][i - 1].submenu[j - 1].url);
        } else {
            history.push(CNF.basename ? `${CNF.basename}${CNF[[props.nav]][m - 1].url}` : CNF[[props.nav]][m - 1].url);
        }
    }, [props.nav, m]);

    const setNavItem = (m) => {
        var com = ''
        if (props.nav === 'navItems') {
            switch (m.toString()) {
                case '11':
                    com = <OrgInfo btnLists={btnLists} preGroup={preGroup} />;
                    break;
                case '12':
                    com = <OrgStructure btnLists={btnLists} preGroup={preGroup} serviceCodes={serCodes} colorPrimary={colorPrimary} />;
                    break;
                case '13':
                    com = <OrgStructureGraph btnLists={btnLists} />;
                    break;
                case '14':
                    com = <OrgApikey btnLists={btnLists} preGroup={preGroup} serviceCodes={serCodes} colorPrimary={colorPrimary} />;
                    break;
                case '21':
                    com = <Users btnLists={btnLists} preGroup={preGroup} />;
                    break;
                case '22':
                    com = <UserInfos btnLists={btnLists} preGroup={preGroup} />;
                    break;
                case '3':
                    com = <Groups btnLists={btnLists} />;
                    break;
                case '4':
                    com = <Roles btnLists={btnLists} />;
                    break;
                case '5':
                    com = <Authoritys btnLists={btnLists} />;
                    break;
                case '61':
                    com = <UserUTACD collapsed={collapsed} btnLists={btnLists} />;
                    break;
                case '62':
                    com = <UserUDATC collapsed={collapsed} btnLists={btnLists} />;
                    break;
                case '63':
                    com = <UserUDEBC collapsed={collapsed} btnLists={btnLists} />;
                    break;
                case '64':
                    com = <UserUDSXC collapsed={collapsed} btnLists={btnLists} />;
                    break;
                case '65':
                    com = <UserUTECY collapsed={collapsed} btnLists={btnLists} />;
                    break;
                case '66':
                    com = <UserUDBCY collapsed={collapsed} btnLists={btnLists} />;
                    break;
                case '71':
                    com = <LogOperations btnLists={btnLists} />;
                    break;
                case '72':
                    com = <LogLogins />;
                    break;
                default:
                    break;
            }
        } else {
            switch (m.toString()) {
                case '1':
                    com = <Seurity m={m} preGroup={preGroup} />;
                    break;
                case '2':
                    com = <BasicInfo m={m} preGroup={preGroup} setThemeColor={props.setThemeColor} navLists={navLists} />;
                    break;
                default:
                    break;
            }
        }

        return com
    }

    return (
        <ConfigProvider
            theme={{
                components: {
                    Table: {
                        headerBorderRadius: 0,              //  表头圆角
                        headerBg: colorPrimaryBg,           // 表头背景色
                        headerSortHoverBg: colorPrimaryBg,  // 表头排序悬浮背景色
                        headerSortActiveBg: colorPrimaryBg, // 表头排序激活背景色
                        // rowHoverBg: colorPrimaryBg,         // 表格行悬浮背景色
                        borderColor: cookie.load(CNF.cookies.keyIsDisplayTableBorder) > 0 ? colorPrimaryBg : colorWhite, // 表格边框色
                        headerSplitColor: colorPrimaryBg,   // 表头分割线色
                    },
                    Tooltip: {
                        colorBgSpotlight: colorPrimary,
                    },
                    Select: {
                        optionActiveBg: colorPrimaryBg,
                    },
                },
            }}
        >
            {/* 服务发布消息 */}
            <ServiceReleaseMessage themeColor={props.themeColor} serInfos={serInfos} />
            <Layout style={{ height: winHeight - 20.5 }}>
                {contextHolder}
                <Sider
                    trigger={null}
                    collapsible
                    collapsed={collapsed}
                >
                    <XMenuLogo collapsed={collapsed} />
                    <XMenu
                        btnLists={btnLists}
                        navItems={CNF[props.nav]}
                        nav={props.nav}
                        collapsed={collapsed}
                        setM={setM}
                        m={m}
                    />
                </Sider>
                <Layout style={{
                    background: colorPrimaryBg,
                }}>
                    <XHeader
                        navLists={navLists}
                        collapsed={collapsed}
                        setCollapsed={setCollapsed}
                        isCompact={props.isCompact}
                        setIsCompact={props.setIsCompact}
                        setThemeColor={props.setThemeColor}
                    />
                    <Content
                        style={{
                            margin: '20px 20px 0 20px',
                            background: colorWhite,
                            borderRadius: borderRadiusLG,
                        }}
                    >
                        {
                            setNavItem(m)
                        }
                    </Content>
                    <XFooter />
                </Layout>
            </Layout>
        </ConfigProvider>
    );
}

const App = (props) => {
    // 切换主体色
    const [themeColor, setThemeColor] = useState(cookie.load(CNF.cookies.keyThemeColor) ? cookie.load(CNF.cookies.keyThemeColor) : CNF.themeColors[0]);
    // 是否紧凑的
    const [isCompact, setIsCompact] = useState(false);
    return (
        <ConfigProvider
            locale={locale}
            variant='outlined'
            theme={{
                algorithm: isCompact ? compactAlgorithm : defaultAlgorithm,
                token: {
                    colorPrimary: themeColor,
                },
            }}
        >
            <Main
                m={props.m}
                nav={props.nav}
                themeColor={themeColor}
                setThemeColor={setThemeColor}
                isCompact={isCompact}
                setIsCompact={setIsCompact}
            />
        </ConfigProvider>
    )
};
export default App